import { request } from "./HttpService";

/** Admin: the scheduler switch, as { scheduler: { enabled, updatedAt, updatedBy } }. */
export function fetchSchedulerSetting() {
    return request("GET", "/admin/scheduler");
}

/**
 * Admin: switch the scheduler on or off. While it's off, deepthought-scheduler skips
 * its runs (so new papers wait in the queue). Resolves { success, scheduler }.
 */
export function setSchedulerEnabled(enabled) {
    return request("PUT", "/admin/scheduler", { enabled });
}
